import { GasDistributionStationGasThreads } from '@gasbi/shared/web/Gds';
import { RouteObject } from 'react-router-dom';

import { Pages } from '@/pages';

import Information from './views/Information';

export const gdsGasDistributionStationDetailsRoutes: RouteObject[] = [
  {
    element: <Information />,
    index: true,
  },
  {
    path: Pages.GAS_THREADS,
    element: <GasDistributionStationGasThreads />,
  },
];
